import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors } from '@lean-body/components/styles';
export const DiagnosisWorkoutLevelCard = ({ label, filledCount }) => {
    return (React.createElement("div", { className: css(styles.card) },
        React.createElement("div", { className: css(styles.cardTitle) }, "\u30EF\u30FC\u30AF\u30A2\u30A6\u30C8\u30EC\u30D9\u30EB"),
        React.createElement("div", { className: css(styles.cardLevel) }, label),
        React.createElement("div", { className: css(styles.barRow) }, [0, 1, 2].map((i) => (React.createElement("div", { key: i, className: css(styles.barSegment, i < filledCount ? styles.barFilled : styles.barEmpty) }))))));
};
const styles = StyleSheet.create({
    card: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
    cardTitle: {
        fontSize: 12,
        fontWeight: 'bold',
        color: Colors.Black,
        letterSpacing: 0.48,
        lineHeight: '100%',
    },
    cardLevel: {
        fontSize: 16,
        fontWeight: 'bold',
        color: Colors.TextDark,
        lineHeight: '100%',
    },
    barRow: {
        display: 'flex',
        gap: 5,
    },
    barSegment: {
        width: 38,
        height: 7,
        borderRadius: 2,
    },
    barFilled: {
        backgroundColor: Colors.Orange,
    },
    barEmpty: {
        backgroundColor: '#FFDBCC',
    },
});
